import getBITSEndApiMap from "../apiMap";
import { api } from "../services/AxiosService";

interface ApiResponse<T = any> {
  data: T;
}

interface ResourceProfile {
  id: string;
  name: string;
  ram: string;
  cpu: string;
  studentCount: number;
  projectCount: number;
}

interface TopResourceProfilesResponse {
  days: number;
  profiles: ResourceProfile[];
}

interface SandboxTimeExtension {
  id: string;
  user_id: string;
  user_name: string;
  extension_duration: number;
  reason: string;
  requested_at: string;
  approved_at?: string;
  status: string;
}

interface SandboxTimeExtensionStats {
  pending: number;
  approved: number;
  rejected: number;
  expired: number;
  total: number;
}

interface SandboxTimeExtensionResponse {
  days: number;
  stats: SandboxTimeExtensionStats;
}

export async function getAdminDashboardData() {
  const url = `${getBITSEndApiMap("adminDashboard")}`;
  const { data } = await api.get<ApiResponse>(url);
  return data.data;
}

export async function getTopResourceProfiles(days: number = 1): Promise<ResourceProfile[]> {
  const url = `${getBITSEndApiMap("adminDashboard")}/top-resource-profiles?days=${days}`;
  const { data } = await api.get<ApiResponse<TopResourceProfilesResponse>>(url);
  return data.data.profiles;
}

export async function getSandboxTimeExtensions(days: number = 1): Promise<SandboxTimeExtensionStats> {
  const url = `${getBITSEndApiMap("adminDashboard")}/sandbox-time-extensions?days=${days}`;
  const { data } = await api.get<ApiResponse<SandboxTimeExtensionResponse>>(url);
  return data.data.stats;
}